import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

export class ManageAccessResponsibleForm extends FormGroup {
  readonly componentId = this.get('departmentId') as FormControl<string>;
  readonly isRecursive = this.get('isRecursive') as FormControl<boolean>;
  readonly shouldOverwriteAccess = this.get('shouldOverwriteAccess') as FormControl<boolean>;
  readonly accessPositions = this.get('accessPositions') as FormControl<string[]>;
  readonly accessPositionGroups = this.get('accessPositionGroups') as FormControl<string[]>;
  readonly accessAssignments = this.get('accessAssignments') as FormControl<string[]>;
  readonly responsibleForPositions = this.get('responsibleForPositions') as FormControl<string[]>;
  readonly responsibleForPositionGroups = this.get('responsibleForPositionGroups') as FormControl<
    string[]
  >;
  readonly accessRoles = this.get('accessRoles') as FormControl<string[]>;
  readonly responsibleForRoles = this.get('responsibleForRoles') as FormControl<string[]>;

  constructor(
    componentId: string,
    readonly fb: FormBuilder = new FormBuilder()
  ) {
    super(
      fb.group({
        componentId: [componentId],
        isRecursive: [false],
        shouldOverwriteAccess: [false],
        accessPositions: [[]],
        accessPositionGroups: [[]],
        accessAssignments: [[]],
        responsibleForPositions: [[]],
        responsibleForPositionGroups: [[]],
        accessRoles: [[]],
        responsibleForRoles: [[]],
      }).controls
    );
  }
}
